(ns practitest.frontend.common-entities.batch-delete-modal
  (:require
   [clojure.string :as str]
   [practitest.frontend.common-entities :refer [over-batch-limit]]
   [practitest.frontend.common-entities.events :as events]
   [practitest.frontend.common-entities.metadata :refer [get-entity-name]]
   [practitest.frontend.common.format-utils :as fu]
   [practitest.frontend.common.i18n :refer [format-translation get-translation]]
   [practitest.frontend.components.confirmation :as confirmation]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]))

(defn- ids-summary
  "e.g. \"TestSets Ids: 1, 2, 3...\"; built from the already-loaded grid rows."
  [entity state-key selection plural-name]
  (cond
    (= selection :_all) (str "All " plural-name)

    (seq selection)
    (let [rows @(re-frame/subscribe [::grid.subs/data [entity state-key]])
          display-ids (->> rows
                            (filter #(contains? selection (:id %)))
                            (map :display_id))]
      (when (seq display-ids)
        (fu/truncate-text (str plural-name " Ids: " (str/join ", " display-ids)) 70)))))

(defn batch-delete-confirmation-modal
  "Shared grid batch-delete confirmation modal; one instance per entity index page."
  [entity]
  (let [{:keys [show? state-key selection current-view] :as _details}
        @(re-frame/subscribe [::events/batch-delete-confirmation entity])
        entity-key-str (name entity)
        plural-name (get-entity-name entity :plural-name)
        n (when show? (events/batch-selection-count entity state-key selection))
        summary (when show? (ids-summary entity state-key selection plural-name))
        body (format-translation
              (get-translation (str entity-key-str ".batch-confirm.delete.body")
                                ;; Test sets can be restored (see suites#restore), unlike other entities.
                                (if (= entity :testset)
                                  "This operation will delete %{count} %{entities}. %{ids-summary}"
                                  "This operation will permanently delete %{count} %{entities}. %{ids-summary}"))
              :count n :entities plural-name
              :ids-summary (if summary (str summary ". ") ""))]
    [confirmation/confirm
     {:show? (reagent/atom (boolean show?))
      :title (format-translation
              (get-translation "entity.batch-confirm.delete.title" "Delete %{entities}?")
              :entities plural-name)
      :body body
      :yes-label (get-translation "generic.button.delete" "Delete")
      :no-label (get-translation "generic.button.cancel" "Cancel")
      :on-yes #(re-frame/dispatch [::events/batch-delete-entity entity])
      :on-no #(re-frame/dispatch [::events/close-batch-delete-confirmation entity])
      :test-id "batch-delete-confirm-btn"
      :dialog-test-id "batch-delete-confirm-dialog"
      :entity-name plural-name
      :destructive? true
      :close-on-escape? true
      :require-typed-confirmation
      {:word "delete"
       :placeholder (get-translation "entity.batch-confirm.delete.type-to-confirm.placeholder" "Type Delete")
       :label (get-translation "entity.batch-confirm.delete.type-to-confirm.label" "Type Delete to confirm")}}]))

(defn open!
  "Opens the modal for `entity`; `opts` needs :state-key :selection :current-view :optional-params."
  [entity {:keys [state-key selection] :as opts}]
  (let [n (events/batch-selection-count entity state-key selection)]
    (when-not (over-batch-limit n)
      (re-frame/dispatch [::events/open-batch-delete-confirmation entity opts]))))
